import { v1 as uuidv1 } from 'uuid';
import { Charsets, CharsetStringType, defaultRtn, findDeclareTypeById, IdLenghtType, LetterFixType, RtnType } from '../declareTypes';
import dayjs from 'dayjs';

/** Uuid定量 大写、小写与数字 */
const shortArray = ["a", "b", "c", "d", "e", "f",
    "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s",
    "t", "u", "v", "w", "x", "y", "z", "0", "1", "2", "3", "4", "5",
    "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I",
    "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V",
    "W", "X", "Y", "Z"];

/** Uuid定量 大写与数字 */
const shortUppercaseArray = ["A", "B", "C", "D", "E", "F",
    "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S",
    "T", "U", "V", "W", "X", "Y", "Z", "0", "1", "2", "3", "4", "5",
    "6", "7", "8", "9"];

/** Uuid定量 小写与数字 */
const shortLowercaseArray = ["a", "b", "c", "d", "e", "f",
    "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s",
    "t", "u", "v", "w", "x", "y", "z", "0", "1", "2", "3", "4", "5",
    "6", "7", "8", "9"];

/** id处理 */
const idHandle = async () => { };

/** interface shortUuidOptions */
export interface ShortUuidOptions {
    /** 短码长度，默认：32位 */
    idLenght?: IdLenghtType,
    /** 字母类型，默认：lowercase */
    letterFix?: LetterFixType
};

/**
 * 获取Uuid短码
 * @param options 选项
 * @returns 返回 Uuid
 */
idHandle.getShortUuid = (options?: ShortUuidOptions) => {
    let { idLenght = 32, letterFix = 'LOWERCASE' } = options || {};
    let uid = uuidv1();
    uid = uid.replace(/-/g, "");
    let buffer = [];
    for (let i = 0; i < idLenght; i++) {
        let start = 0;
        let end = 0;
        switch (idLenght) {
            case 8:
                start = i * 4;
                end = i * 4 + 4;
                break;
            case 32:
                if (letterFix !== "LOWERCASE") {
                    uid.toUpperCase();
                }
                return uid;
                break;
            default:
                start = i * 2;
                end = i * 2 + 2;
                break;
        }
        let str = uid.substring(start, end);
        if (letterFix === "LOWERCASE") {
            buffer.push(shortLowercaseArray[parseInt(str, 16) % 36])
        }
        else if (letterFix === "UPPERCASE") {
            buffer.push(shortUppercaseArray[parseInt(str, 16) % 36])
        }
        else {
            buffer.push(shortArray[parseInt(str, 16) % 62])
        }
    }
    return buffer.join("");
};

/** interface SnowflakeOptions */
export interface SnowflakeOptions {
    /** 前缀id */
    prefixId?: string,
    /** 5位机器ID (0-31) */
    workerId?: bigint,
    /** 5位数据中心ID (0-31) */
    dataCenterId?: bigint,
    /** 起始时间戳13位，毫秒/秒（默认2022-07-01 00:00:00 0000） */
    epoch?: bigint,
    /** 后缀id */
    suffixId?: string
};

/**
 * 创建Snowflake ID生成器（函数式实现）
 * @param options 选项
 */
idHandle.createSnowflake = (
    options?: SnowflakeOptions
) => {
    let { prefixId, workerId = 1n, dataCenterId = 1n, epoch = 1656633600000n, suffixId } = options || {};
    // 校验参数范围
    if (workerId < 0n || workerId > 31n) {
        workerId = 1n;
    }
    if (dataCenterId < 0n || dataCenterId > 31n) {
        dataCenterId = 1n;
    }
    // 位移配置
    /** 序列号位数 */
    const workerShift = 12n;
    /** workerShift + 5位机器ID */
    const dcShift = 17n;
    /** dcShift + 5位数据中心ID */
    const tsShift = 22n;
    /** 2^12 -1 */
    const seqMask = 4095n;
    // 状态变量
    let lastTimestamp = -1n;
    let sequence = 0n;
    /** 全局偏移量 */
    // let timeOffset = 0n;
    // 核心生成方法
    return (createOptions?: {
        /** 前缀id */
        currentPrefixId?: string,
        /** 后缀id */
        currentSuffixId?: string
    }) => {
        const { currentPrefixId = prefixId, currentSuffixId = suffixId } = createOptions || {};
        let ts = BigInt(Date.now());
        // 时钟回拨检测
        if (ts < lastTimestamp) {
            // timeOffset += lastTimestamp - ts;
            // 临时使用旧时间戳
            ts = lastTimestamp;
        } else {
            // 重置偏移量
            // timeOffset = 0n;
        }
        // 同一毫秒内递增序列号
        if (ts === lastTimestamp) {
            sequence = (sequence + 1n) & seqMask;
            if (sequence === 0n) {
                // 序列耗尽时等待下一毫秒
                while ((ts = BigInt(Date.now())) <= lastTimestamp) { }
            }
        } else {
            sequence = 0n;
        }
        lastTimestamp = ts;
        /** 组合各部分生成ID */
        const snowflakeId = (
            ((ts - epoch) << tsShift) |
            (dataCenterId << dcShift) |
            (workerId << workerShift) |
            sequence
        ).toString();
        return `${currentPrefixId || ''}${snowflakeId}${currentSuffixId || ''}`;
    };
};

/** SnowflakeOptions扩展 */
export declare interface SnowflakeOptionsEx extends SnowflakeOptions {
    /** 时间精度（'ms'毫秒/'us'微秒） */
    precision?: 'ms' | 'µs';
    /** 总位数：64n  128n */
    totalBits?: bigint;
};

/**
 * 创建Snowflake ID生成器（支持可变位数，毫秒/微秒可选）
 * @param options 选项
 */
idHandle.createSnowflakeEx = (
    options?: SnowflakeOptionsEx
) => {
    let {
        prefixId,
        workerId = 1n,
        dataCenterId = 1n,
        epoch = 1656633600000n,
        suffixId,
        // 新增参数
        precision = 'µs',  // 'ms'毫秒 或 'µs'微秒(默认)
        totalBits = 80n,  // 总位数：64,  90(默认), 96，128
    } = options || {};
    // 精度配置
    const isMicrosecond = precision === 'µs';
    const timestampMultiplier = isMicrosecond ? 1000n : 1n;
    const epochAdjusted = epoch * timestampMultiplier;
    // 根据总位数动态分配各部分的位数
    const bitConfig = {
        // 默认配置：时间戳42位，数据中心5位，机器5位，序列号12位（共64位）
        timestampBits: totalBits - 34n,      // 时间戳（默认42位，毫秒可用69年）
        dataCenterIdBits: 5n,    // 数据中心ID
        workerIdBits: 5n,        // 机器ID
        sequenceBits: 14n,       // 序列号
    };
    // 计算各部分的掩码和最大值
    const {
        timestampBits,
        dataCenterIdBits,
        workerIdBits,
        sequenceBits
    } = bitConfig;
    const maxDataCenterId = (1n << dataCenterIdBits) - 1n;
    const maxWorkerId = (1n << workerIdBits) - 1n;
    const seqMask = (1n << sequenceBits) - 1n;
    // 校验参数范围
    if (workerId < 0n || workerId > maxWorkerId) {
        console.warn(`workerId超出范围(0-${maxWorkerId})，已重置为1`);
        workerId = 1n;
    }
    if (dataCenterId < 0n || dataCenterId > maxDataCenterId) {
        console.warn(`dataCenterId超出范围(0-${maxDataCenterId})，已重置为1`);
        dataCenterId = 1n;
    }
    // 验证总位数
    const actualTotalBits = timestampBits + dataCenterIdBits + workerIdBits + sequenceBits;
    if (actualTotalBits !== totalBits) {
        console.warn(`配置错误：各部分位数之和(${actualTotalBits})不等于totalBits(${totalBits})`);
    }
    // 位移配置（从低位到高位）
    const workerShift = sequenceBits;                     // 序列号在最低位
    const dcShift = workerShift + workerIdBits;          // 机器ID在上
    const tsShift = dcShift + dataCenterIdBits;          // 时间戳在最高位
    // 验证时间戳范围
    const maxTimestamp = (1n << timestampBits) - 1n;
    // 计算最大可用年数
    // function calculateMaxYears(bits: bigint, isMicro: boolean): number {
    //     const maxValue = (1n << bits) - 1n;
    //     // 每年的单位数（按365天计算）
    //     const unitsPerYear = isMicro ?
    //         1000n * 1000n * 60n * 60n * 24n * 365n :  // 微秒/年
    //         1000n * 60n * 60n * 24n * 365n;          // 毫秒/年
    //     // 计算年数（使用BigInt进行整数除法）
    //     const years = Number(maxValue / unitsPerYear);
    //     return Math.floor(years);
    // }
    // const maxTimeYears = calculateMaxYears(timestampBits, isMicrosecond);
    // console.log(`Snowflake配置：总${totalBits}位，时间戳${timestampBits}位，可用约${maxTimeYears}年`);
    // 状态变量
    let lastTimestamp = -1n;
    let sequence = 0n;
    let timeOffset = 0n;
    let lastCalibrationTime = 0n;
    let calibrationOffset = 0n;
    // 时间戳获取函数
    const getTimestamp = () => {
        if (isMicrosecond) {
            // 微秒精度实现
            return getMicrosecondTimestamp();
        } else {
            // 毫秒精度
            return BigInt(Date.now());
        }
    };
    // 微秒时间戳获取（兼容实现）
    const getMicrosecondTimestamp = () => {
        let microTimestamp: bigint;
        if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
            // 浏览器环境：使用performance.now()获取微秒精度
            const nowMs = Date.now();
            const perfMs = performance.now();
            // 校准：确保单调递增
            if (nowMs > lastCalibrationTime) {
                calibrationOffset = BigInt(nowMs) * 1000n - BigInt(Math.floor(perfMs * 1000));
                lastCalibrationTime = BigInt(nowMs);
            }
            microTimestamp = BigInt(Math.floor(perfMs * 1000)) + calibrationOffset;
        } else if (typeof process !== 'undefined' && process.hrtime) {
            // Node.js环境：使用process.hrtime()
            const hrtime = process.hrtime();
            const nowMs = Date.now();
            if (nowMs > lastCalibrationTime) {
                // 计算纳秒转微秒的校准偏移
                calibrationOffset = BigInt(nowMs) * 1000n -
                    (BigInt(hrtime[0]) * 1_000_000_000n + BigInt(hrtime[1])) / 1000n;
                lastCalibrationTime = BigInt(nowMs);
            }
            microTimestamp = (BigInt(hrtime[0]) * 1_000_000_000n + BigInt(hrtime[1])) / 1000n + calibrationOffset;
        } else {
            // 回退方案：毫秒×1000 + 序列号模拟微秒
            const ms = BigInt(Date.now());
            microTimestamp = ms * 1000n + (sequence % 1000n);
        }
        return microTimestamp;
    };
    // 自适应等待函数
    const adaptiveWait = (diff: bigint) => {
        // 将时间差转换为毫秒数等待
        const waitMs = Math.min(Number(diff) / Number(timestampMultiplier) * 1.1, 1000); // 最多等1秒
        const start = Date.now();
        while (Date.now() - start < waitMs) {
            // 空循环等待
        }
        return getTimestamp();
    };
    // 核心生成方法
    return (createOptions?: {
        currentPrefixId?: string,
        currentSuffixId?: string
    }) => {
        const { currentPrefixId = prefixId, currentSuffixId = suffixId } = createOptions || {};
        let ts = getTimestamp();
        let retryCount = 0;
        const maxRetries = 10;
        // 时钟回拨处理（自适应等待）
        while (ts < lastTimestamp && retryCount < maxRetries) {
            const diff = lastTimestamp - ts;
            // 小幅度回拨：等待追赶
            if (diff < 100n * timestampMultiplier) {
                ts = adaptiveWait(diff);
            }
            // 大幅度回拨：使用偏移量补偿
            else {
                timeOffset += diff;
                retryCount++;
                if (retryCount === maxRetries) {
                    console.warn(`Snowflake时钟回拨超过${maxRetries}次，总偏移${timeOffset}`);
                    // 重置状态，强制使用新时间
                    lastTimestamp = -1n;
                    sequence = 0n;
                }
            }
            if (retryCount < maxRetries) {
                ts = getTimestamp(); // 重新获取时间
            }
        }
        // 重置重试计数
        retryCount = 0;
        // 同一时间单位内处理
        if (ts === lastTimestamp) {
            sequence = (sequence + 1n) & seqMask;
            if (sequence === 0n) {
                // 序列耗尽时等待下一时间单位
                let nextTs = getTimestamp();
                // 同步等待，避免异步
                while (nextTs <= lastTimestamp) {
                    // 短暂等待避免CPU占用过高
                    if (typeof setImmediate === 'function') {
                        // Node.js环境：使用setImmediate但不同步等待
                        // 这里我们改为简单的循环等待
                        const start = Date.now();
                        while (Date.now() - start < 1) {
                            // 等待1ms
                        }
                    }
                    nextTs = getTimestamp();
                }
                ts = nextTs;
            }
        } else {
            sequence = 0n;
        }
        lastTimestamp = ts;
        // 应用时间偏移补偿
        const adjustedTs = ts + timeOffset;
        // 计算相对时间戳（从epoch开始）
        const relativeTs = adjustedTs - epochAdjusted;
        // 检查时间戳是否超出范围
        if (relativeTs > maxTimestamp) {
            throw new Error(`时间戳超出范围：相对时间${relativeTs} > 最大值${maxTimestamp}`);
        }
        /** 组合各部分生成ID */
        const snowflakeId = (
            (relativeTs << tsShift) |
            (dataCenterId << dcShift) |
            (workerId << workerShift) |
            sequence
        ).toString();
        // 验证ID长度
        // const expectedMaxLength = Math.ceil(Number(totalBits) * Math.log10(2));
        // if (snowflakeId.length > expectedMaxLength) {
        // console.warn(`生成的ID长度${snowflakeId.length}超过预期最大值${expectedMaxLength}`);
        // }
        return `${currentPrefixId || ''}${snowflakeId}${currentSuffixId || ''}`;
    };
};

/**
 * crypto.getRandomValues模拟实现（非加密安全）
 * @param array 数组 
 */
const mockGetRandomValues = <T extends ArrayBufferView>(array: T): T => {
    const buffer = array.buffer;
    const byteView = new Uint8Array(buffer);
    // 使用 Math.random() 生成伪随机字节（非加密安全）
    for (let i = 0; i < byteView.length; i++) {
        byteView[i] = Math.floor(Math.random() * 256);
    }
    return array;
};

/**
* 生成id
* @param options 
* @returns 
*/
idHandle.generateBaseId = (options?: {
    /**　起始时间，不能使用未来时间，默认：2020-01-01 00:00:00 UTC */
    startEpoch?: Date,
    /** 时间部份长度，默认：8 */
    timePartLength?: number,
    /** 随机部份长度，默认：3 */
    randomPartLength?: number,
    /** 字符集，默认：'BASE36' */
    charset?: CharsetStringType,
    /** 扩展字符集，例如：+、/、#、@....字符串 */
    extendCharset?: string,
    /** 机器id，如需要，必需传入2位Base62字符（校验），如不符合规则使用：'A1' */
    machineId?: string,
    /** 前缀id */
    prefixId?: string,
    /** 后缀id */
    suffixId?: string,
    /** 时间精度级别：'ms'(毫秒,默认) | 'µs'(微秒) | 'ns'(纳秒) */
    timePrecision?: 'ms' | 'µs' | 'ns'
}): RtnType => {
    const rtn = defaultRtn();
    try {
        const {
            startEpoch,
            timePartLength = 8,
            randomPartLength = 3,
            charset = 'BASE36',
            extendCharset,
            machineId,
            prefixId,
            suffixId,
            timePrecision = 'ms'
        } = options || {};
        let BASE = findDeclareTypeById(Charsets.getAll(), charset)?.data;
        if (typeof extendCharset !== 'undefined') {
            BASE = `${BASE}${extendCharset}`;
        }
        const baseLength = BASE.length > 0 ? BASE.length : 36;
        /** 将数字转换为字符串 */
        const toBase = (num: number, padLength: number): string => {
            let result = '';
            do {
                result = BASE[num % baseLength] + result;
                num = Math.floor(num / baseLength);
            } while (num > 0);
            return result.padStart(padLength, '0');
        };
        // 1. 计算时间部分
        const START_EPOCH = typeof startEpoch === 'undefined' ? 1577836800000 : dayjs(startEpoch).valueOf();
        // 计算时间差
        const now = Date.now();
        let reducedTime = now - START_EPOCH;
        if (reducedTime < 0) {
            reducedTime = 0;
        }
        // 根据精度级别处理时间
        let timeValue = reducedTime;
        if (timePrecision === 'µs' || timePrecision === 'ns') {
            try {
                // 获取高精度时间
                let subMillisecond = 0;
                let multiplier = 1;
                if (timePrecision === 'µs') {
                    multiplier = 1000; // 毫秒转微秒
                } else if (timePrecision === 'ns') {
                    multiplier = 1000000; // 毫秒转纳秒
                }
                // 浏览器环境
                if (typeof performance !== 'undefined' && performance.now) {
                    const perfNow = performance.now();
                    // 取毫秒的小数部分
                    const fraction = perfNow % 1;
                    if (timePrecision === 'µs') {
                        // 转换为微秒 (0-999)
                        subMillisecond = Math.floor(fraction * 1000);
                    } else if (timePrecision === 'ns') {
                        // 转换为纳秒 (0-999999)
                        // 注意: performance.now() 精度通常是微秒级，这里乘以1000得到模拟纳秒
                        subMillisecond = Math.floor(fraction * 1000000);
                    }
                }
                // Node.js 环境 - 支持真纳秒
                else if (typeof process !== 'undefined' && process.hrtime) {
                    const hrtime = process.hrtime();
                    // hrtime[0] 秒, hrtime[1] 纳秒

                    if (timePrecision === 'µs') {
                        // 将纳秒转换为微秒
                        subMillisecond = Math.floor(hrtime[1] / 1000) % 1000;
                    } else if (timePrecision === 'ns') {
                        // 直接使用纳秒部分
                        subMillisecond = hrtime[1] % 1000000;
                    }
                }
                // 回退方案：使用高精度时间模拟
                else {
                    // 获取高精度时间（如果可用）
                    const getHighResTimestamp = (): number => {
                        if (typeof performance !== 'undefined' && performance.now) {
                            return performance.now();
                        } else if (typeof process !== 'undefined' && process.hrtime) {
                            const hr = process.hrtime();
                            return hr[0] * 1000 + hr[1] / 1000000;
                        } else {
                            return Date.now();
                        }
                    };
                    const highResTime = getHighResTimestamp();
                    const fraction = highResTime % 1;
                    if (timePrecision === 'µs') {
                        subMillisecond = Math.floor(fraction * 1000);
                    } else if (timePrecision === 'ns') {
                        subMillisecond = Math.floor(fraction * 1000000);
                    }
                }
                // 合并时间：毫秒部分 + 子毫秒部分
                timeValue = reducedTime * multiplier + subMillisecond;
            } catch (error: any) {
                // 高精度时间获取失败，回退到毫秒级
                console.warn(`高精度时间获取失败，回退到毫秒级时间: ${error.message}`);
                timeValue = reducedTime;
            }
        }
        const timePart = toBase(timeValue, timePartLength);
        /** 2. 机器id */
        let machineIdPart = '';
        if (typeof machineId !== 'undefined') {
            // 机器码校验（必须为2位Base62字符）
            if (machineId.length !== 2 || !/^[0-9a-zA-Z]{2}$/.test(machineId)) {
                //如不符合规则，使用默认：'A1'
                machineIdPart = 'A1';
            } else {
                machineIdPart = machineId;
            }
        }
        // 3. 生成随机部分
        const randomPart = Array.from({ length: randomPartLength }, () => {
            const randomBuffer = mockGetRandomValues(new Uint32Array(1));
            const max = baseLength;
            const random = randomBuffer[0] / (0xFFFFFFFF + 1);
            return BASE[Math.floor(random * max)];
        }).join('');
        // 4. 合并ID
        rtn.success = true;
        rtn.data = `${typeof prefixId !== 'undefined' ? prefixId : ''}${timePart}${machineIdPart}${randomPart}${typeof suffixId !== 'undefined' ? suffixId : ''}`;
    }
    catch (error: any) {
        rtn.message = '生成错误';
        if (error.message) rtn.message += `: ${error.message}`;
    }
    return rtn;
};

export default idHandle;